import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { getFileExtension } from '../../helpers/Files';

class FileExtension extends PureComponent {
  render() {
    const { file } = this.props;

    const extension = getFileExtension(file);
    if (!extension) {
      return null;
    }

    return (
      <span className="file-extension">
        {extension}
      </span>
    );
  }
}

FileExtension.propTypes = {
  file: PropTypes.object.isRequired,
};

export default FileExtension;
